import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {AxiosError} from "axios";
import useApi from "../../../utils/custom-hooks/api-hooks/useApi";
import {IFinalBalance} from "../../../utils/interfaces/FinalBalance/IFinalBalance";


const useApiGetUserEstimates = (user_id: number | undefined): UseQueryResult<IFinalBalance[], AxiosError> => {
    const {get} = useApi()

    async function doGet(user_id: number | undefined): Promise<IFinalBalance[]> {
        try {
            const response = await get(`/users/${user_id}/finalbalances`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetUserFinalBalances", user_id],
        queryFn: () => doGet(user_id),
        enabled: !!user_id
    })
};

export default useApiGetUserEstimates
